// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._16id7YcyrOuIiV {\n  margin: 8px 0 0 0;\n}\n.nQ57ppjPu-FbU5 {\n  height: 24px;\n  width: 32px;\n  min-width: 32px;\n  padding: 0;\n  margin: 0;\n  border-radius: 3px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"clearButton": "_16id7YcyrOuIiV",
	"labelModSquare": "nQ57ppjPu-FbU5"
};
export default ___CSS_LOADER_EXPORT___;
